export class UnlockUserDto {
  userId: string;

  constructor(data: { userId: string }) {
    this.userId = data.userId;
  }
}
